__turbopack_context__.v({
  "popupEnter": "MapMarker-module__v13Wja__popupEnter",
});
